export class UtilArray {
    static defaultComparator(value1, value2) {
        return value1 === value2;
    }
    static intersection(array1, array2, comparator) {
        const temp = [];
        const thisComparator = comparator ? comparator : UtilArray.defaultComparator;
        for (let i = 0; i < array1.length; i++) {
            for (let j = 0; j < array2.length; j++) {
                if (thisComparator(array1[i], array2[j])) {
                    temp.push(array1[i]);
                    break;
                }
            }
        }
        return temp;
    }
    static union(array1, array2, comparator) {
        const temp = array1.concat([]);
        if (!temp || !temp.length) {
            return array2.concat([]);
        }
        const thisComparator = comparator ? comparator : UtilArray.defaultComparator;
        for (let i = 0; i < array2.length; i++) {
            if (!UtilArray.contains(temp, array2[i], thisComparator)) {
                temp.push(array2[i]);
            }
        }
        return temp;
    }
    static exclude(sourceArr, excludedArr, comparator) {
        const temp = [];
        if (!excludedArr || !excludedArr.length) {
            return sourceArr;
        }
        const thisComparator = comparator ? comparator : UtilArray.defaultComparator;
        for (let i = 0; i < sourceArr.length; i++) {
            if (!UtilArray.contains(excludedArr, sourceArr[i], thisComparator)) {
                temp.push(sourceArr[i]);
            }
        }
        return temp;
    }
    static containsIndex(array, value, comparator) {
        if (!array) {
            return -1;
        }
        const thisComparator = comparator ? comparator : UtilArray.defaultComparator;
        for (let i = 0; i < array.length; i++) {
            if (thisComparator(array[i], value)) {
                return i;
            }
        }
        return -1;
    }
    static contains(array, value, comparator) {
        return UtilArray.containsIndex(array, value, comparator) !== -1;
    }
    static move(arr, src, dest) {
        arr[dest] = arr[src];
        arr[src] = null;
    }
    static deleteSplice(arr, i) {
        arr.splice(i, 1);
    }
    static deleteSetNull(arr, i) {
        arr[i] = null;
    }
    static swap(arr, i1, i2) {
        const tmp1 = arr[i1];
        arr[i1] = arr[i2];
        arr[i2] = tmp1;
    }
    static add(array, item, excludeDuplicated, comparator) {
        if (excludeDuplicated && UtilArray.contains(array, item, comparator)) {
            return false;
        }
        array.push(item);
        return true;
    }
    static addOrReplace(array, item, comparator) {
        const idx = UtilArray.containsIndex(array, item, comparator);
        if (idx !== -1) {
            array[idx] = item;
        }
        else {
            array.push(item);
        }
    }
    static get(array, value, comparator) {
        const idx = UtilArray.containsIndex(array, value, comparator);
        if (value !== -1) {
            return array[idx];
        }
        return null;
    }
}
